/**
 * SitePick front — 価格表示（通常価格 + Sale）の DOM 生成。
 *
 * お気に入り（`favorites.js`）と比較（`compare.js`）が共通で使う。PHP 側の
 * `sitepick_price_block_html()` と**同じマークアップ・同じ意味**を出すためだけのモジュール。
 *
 * ## 割引の計算はここでしない
 *
 * 値引きの判定・金額の決定は **PHP の `PriceResolver`（`ProductState::get()`）が唯一の実装**。
 * このモジュールは REST（`/sitepick/v1/sites`）が返した
 * `regular_price` / `effective_price` / `has_discount` を**そのまま描くだけ**で、
 * 割引率も固定額も期間判定も持たない（JS に値付けのロジックを置かない）。
 *
 * サーバーが古くて上記フィールドを返さない場合は、`price`（通常価格）だけを出す
 * ——JS 側で勝手に割引を作らない。
 */

/** `<data class="p-price" value="…">1,234<span class="p-price__unit">円</span></data>` */
function priceNode(amount) {
  const data = document.createElement("data");
  data.className = "p-price";
  data.value = String(amount);
  data.appendChild(document.createTextNode(Number(amount).toLocaleString("ja-JP")));
  const unit = document.createElement("span");
  unit.className = "p-price__unit";
  unit.textContent = "円";
  data.appendChild(unit);
  return data;
}

/**
 * 価格表示のノードを作る。
 *
 * @param {object} site REST が返した 1 商品（`price` / `regular_price` / `effective_price` / `has_discount`）。
 * @param {string} fallbackText 価格が無いときの文言。
 * @returns {Node}
 */
export function priceBlock(site, fallbackText) {
  const regular = typeof site.regular_price === "number" ? site.regular_price : site.price;
  if (typeof regular !== "number") {
    return document.createTextNode(fallbackText);
  }
  const effective = typeof site.effective_price === "number" ? site.effective_price : regular;
  // 「割引がある」の判定もサーバーの値に従う（金額の比較で JS が独自に決めない）。
  if (site.has_discount !== true || effective >= regular) {
    return priceNode(regular);
  }

  // セール名のラベル → セール価格。通常価格は並べない（PHP の sitepick_price_block_html と同じ。
  // 二重価格表示をしない・2026-10-01 人間判断）。商品カード・商品詳細と同じ構造・同じクラス名。
  const wrap = document.createElement("span");
  wrap.className = "p-price-block";

  const label = document.createElement("span");
  label.className = "p-price-block__label";
  label.textContent = typeof site.sale_name === "string" && site.sale_name !== "" ? site.sale_name : "SALE";
  wrap.appendChild(label);

  const sale = document.createElement("span");
  sale.className = "p-price-block__sale";
  sale.appendChild(priceNode(effective));
  wrap.appendChild(sale);

  return wrap;
}
